import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { useT } from "../i18n/LanguageContext";

export default function Footer() {
  const t = useT();
  return (
    <footer
      className="bg-[#F3F1EA] border-t border-[rgba(26,26,26,0.06)] mt-32 grain"
      data-testid="site-footer"
    >
      <div className="container-x pt-24 pb-12 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-5">
            <Logo />
            <p className="text-[#4A4A4A] text-base mt-8 max-w-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="mt-10 flex items-center gap-6 text-sm">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-[#4A4A4A] hover:text-[#9A7E47] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} />
                Instagram
              </a>
              <a
                href="mailto:eva@sanitybodymindspirit.com"
                className="inline-flex items-center gap-2 text-[#4A4A4A] hover:text-[#9A7E47] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={16} />
                eva@sanitybodymindspirit.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.7rem] uppercase tracking-[0.32em] text-[#9A7E47] mb-6">
              {t("footer.explore")}
            </div>
            <ul className="space-y-3 text-sm">
              {["method", "body", "mind", "spirit", "curriculum", "about", "resources", "contact"].map(
                (k) => (
                  <li key={k}>
                    <Link
                      to={`/${k}`}
                      className="text-[#4A4A4A] hover:text-[#9A7E47] transition-colors"
                      data-testid={`footer-link-${k}`}
                    >
                      {t(`footer.${k}`)}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[0.7rem] uppercase tracking-[0.32em] text-[#9A7E47] mb-6">
              {t("footer.stayBlock")}
            </div>
            <p className="text-[#4A4A4A] text-sm leading-relaxed mb-6">
              {t("footer.staySub")}
            </p>
            <Link
              to="/curriculum"
              className="inline-flex items-center gap-3 text-[#1A1A1A] border-b border-[#B89B5E]/40 pb-2 hover:border-[#B89B5E] transition-all duration-300 text-sm tracking-[0.18em] uppercase font-medium"
              data-testid="footer-waitlist-link"
            >
              {t("footer.stayCta")} <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>

        <div className="hairline mt-20" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10 text-xs text-[#707070]">
          <p>© {new Date().getFullYear()} {t("footer.rights")}</p>
          <p className="tracking-[0.22em] uppercase">{t("footer.meta")}</p>
        </div>
      </div>
    </footer>
  );
}
